import SettingsIcon from '@mui/icons-material/Settings';
import StorageIcon from '@mui/icons-material/Storage';
import InfoIcon from '@mui/icons-material/Info';
import NotificationsIcon from "@mui/icons-material/Notifications";
import EmailIcon from '@mui/icons-material/Email';
import VpnKeyIcon from '@mui/icons-material/VpnKey';   // Key Vault
import LanIcon from '@mui/icons-material/Lan';    

export const appSetting = [
  { name: "Configuraion", value: "cleanUpTab", icon: <SettingsIcon /> },
  // { name: "Data Persistence", value: "rawDataTab", icon: <SaveIcon /> },
  // { name: "DQ Template Server", value: "dqTab", icon: <CloudIcon /> },
  { name: "Data Providers", value: "dProvidersTab", icon: <StorageIcon /> },
  { name: "Node Info", value: "nodeInfoTab", icon: <InfoIcon /> },
  { name: "Notifications", value: "teamTab", icon: <NotificationsIcon /> },
  { name: "Key Vault", value: "keyValutTab", icon: <VpnKeyIcon /> },
  // { name: "Cluster", value: "clusterTab", icon: <LanIcon /> },
  // { name: "Email Notifications", value: "emailTab", icon: <EmailIcon /> },
];


export const headerLogList = [
  { name: "Info", value: "info" },
  { name: "Error", value: "error" },
  { name: "Debug", value: "success" },
];

export const myAccList = [
  { name: "User Details", value: "userDetail" },
  { name: "Manage License", value: "manage" },
  { name: "Change Password", value: "changePass" },
];
